import React, { useEffect, useState } from 'react';
import { getUploadedImagePath, useAppDispatch, useAppState } from '@nutastic/nutastic-react-app';
import { useParams } from 'react-router-dom';
import { WebsiteActions } from '../../state/actions.mjs';
import { CONSTANTS } from '../../utils/constants';
import classnames from 'classnames';
import { useNavigation } from '../../hooks/useNavigation';
import ContentNotFoundPage from './ContentNotFoundPage';

const componentClass = 'listPage';

const ListPage = () => {
    const [ listConfiguration, setListConfiguration ] = useState(null);
    const appDispatch = useAppDispatch();
    const { isProcessing, pages } = useAppState();
    const { loadPage } = useNavigation();
    const { id: listId, type: listType } = useParams();
    const { title: pageTitle, description: pageDescription, sections } = listConfiguration || {};

    useEffect(() => {
        appDispatch({ type: WebsiteActions.LOADING_PAGE_START });
        if (pages.hasOwnProperty(listType)) {
            const dynamicPageConfigs = pages[listType] || [];
            let configToSet = null;
            if(!listId) {
                configToSet = dynamicPageConfigs.length > 0 ? dynamicPageConfigs[0] : null;
            } else {
                dynamicPageConfigs.forEach(conf => {
                    if (conf?.slug === listId) configToSet = conf;
                });
            }
            setListConfiguration(configToSet);
        }
        setTimeout(() => {
            appDispatch({ type: WebsiteActions.LOADING_PAGE_DONE });
        }, 1000);
    }, [listType, listId]);

    const renderContentList = (contentList, type) => {
        const classes = classnames(`${componentClass}__item`, {
            useWideImage: type === CONSTANTS.APPKEY_VIDEOS || type === CONSTANTS.APPKEY_ARTIST || type === CONSTANTS.APPKEY_SERIES,
            shoppaStyle: type === CONSTANTS.APPKEY_SHOP
        });
        return (contentList || []).map(c => {
            const {image, slug, title} = c;
            const urlToLoad = type === CONSTANTS.APPKEY_SHOP ? `/shop/${slug}` : type === CONSTANTS.APPKEY_SERIES ? `/series/${slug}` : `/content/${type}/${slug}`;
            return <div className={classes} onClick={() => loadPage(urlToLoad)}>
                <img src={getUploadedImagePath(image)} alt={`${title} | NuStation`} />
                <div>
                    <p>{ title }</p>
                    <p className="d-none">{ slug }</p>
                </div>
            </div>
        });
    };

    return (!isProcessing && listConfiguration) ? <article className={componentClass}>
        <div className={`${componentClass}__header`}>
            <h1>{ pageTitle }</h1>
        </div>
        {
            (sections || []).filter(s => s.hasOwnProperty('enableField') && s.enableField !== 'false').map((section, i) => {
                const { title, description, sliderItems, type } = section;
                return <div className={`${componentClass}__content`}>
                    <div className={`${componentClass}__section`}>
                        <h2>{ title }</h2>
                        <p>{ description }</p>
                    </div>
                    <div className={`${componentClass}__list`}>
                        { renderContentList(sliderItems, type) }
                    </div>
                </div>;
            })
        }
    </article> : <ContentNotFoundPage isProcessing={isProcessing} /> ;
};

export default ListPage;
